import React from "react";
import "./style.css";
import { useState } from "react";
import DropdownIcon from "../../../Assets/Icons/Dropdown_arrow.svg";
import { usePatientContext } from "../../../Context/PatientContext";
import { getDDMMYY } from "../../../Helpers";

const TreatmentGlance = () => {
  const [open, setOpen] = useState(null);
  const { patientTimeline } = usePatientContext();
  const treatments = patientTimeline.filter(
    (entry) => entry?.type === "Treatment"
  );

  const treatmentData =
    treatments?.length > 0 &&
    treatments?.map((treatment, index) => {
      return {
        id: index,
        name: treatment.name,
        date: getDDMMYY(treatment.endDate),
        procedure: treatment.drugNames,
        details: treatment.description,
      };
    });

  const toggleItem = (id) => {
    setOpen(open === id ? null : id);
  };

  return (
    <div className="treatment-container">
      <div style={{ alignSelf: "start" }}>
        <h6 className="h6-400 dark-grey">Treatment at a Glance</h6>
      </div>

      {/* Render treatment data */}
      {treatmentData?.length > 0 ? (
        treatmentData.map((item) => (
          <div className="box-container" key={item.id}>
            <div className="items">
              <div className="title">
                <div className="title-inner">
                  <p className="body1 dark-grey">{item.name}</p>

                  {item.hasOwnProperty("status") ? (
                    // Display status if present
                    <p className="body2 unique-text">{item.status}</p>
                  ) : null}

                  <div className="title-date">
                    <p className="body2 dark-grey">{item.date}</p>
                  </div>
                </div>

                {/* Dropdown Icon */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => toggleItem(item.id)}
                >
                  <img
                    style={{
                      width: "10px",
                      transform:
                        open === item.id ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "all 0.3s ease-in-out",
                    }}
                    className="dropdown-icon"
                    src={DropdownIcon}
                    alt="dropdown"
                  />
                </div>
              </div>

              {/* Procedure */}
              <div className="details-frame">
                <p className="details blue">{item.procedure}</p>
              </div>

              {/* Content */}
              {open === item.id && (
                <div className="content">
                  {item.hasOwnProperty("details")
                    ? item.details.map((detail, indexD) => (
                        <p
                          className="body1 dark-grey"
                          style={{ marginTop: "5px" }}
                          key={indexD}
                        >
                          {detail}
                        </p>
                      ))
                    : null}
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="box-container">
          <p className="body1 medium-grey">Details not available</p>
        </div>
      )}
    </div>
  );
};

export default TreatmentGlance;
